import TourLandingTemplate from './TourLandingTemplate';
import stopPhotos from './stopPhotos';

function TourSoCal() {
  return (
    <TourLandingTemplate
      location="West Coast Book Launch Celebration"
      date="Norco, CA - April 26, 2026"
      photo={stopPhotos['west-coast-launch']}
      photoAlt="West Coast Book Launch Celebration in Norco, CA"
      flickrUrl="https://www.flickr.com/photos/shawnyork/albums/72177720333342981/"
    />
  );
}

export default TourSoCal;
